import React from "react";
import MasterTable from "../BaseMaster/MasterTable";

function PriorityTable() {
  return (
    <>
      <MasterTable endpoint="/priority" name="Priorities" modalName="Priority" />
    </>
  );
}

export default PriorityTable;
